import { SegmentFactory } from "./SegmentFactory";

export const getSegmentId = () => {
  try {
    const segment = SegmentFactory.getInstance();
    const segmentId = segment.getId();
    return segmentId;
  } catch (error) {
    console.error(error);
  }
};
